<template>
  <div id="app" class="page" :class="brandClass()">
    <div v-show="showpolicy" ref="cookiePage" id="epaas-policy-page-container">
      <div ref="policy_back_button" id="policy_back_button" class="policy_back_button">
        <div class="policy_back_button_img  pointer" @click="closeCookiePage()">
        </div>
        <!--TO REMOVE-->
        <div class="policy_back_button_text pointer" role="button" tabindex="0" @keydown="ariaClick"  @click="closeCookiePage()">
          {{$t('link_page_success_back_to_login_button')}}
        </div>
      </div>
    </div>
    <div v-show="!showpolicy">
      <img
        v-if="$c('show_config_page')"
        style="position: absolute;     
          left: 0;
          cursor:pointer;
          width: 20px;
          z-index: 9999;
          margin: 10px;" 
        src="@/assets/default/light/config-default-light.png" 
        @click="$navigateByPath('config')"
        alt=""
      />
      <div v-if="!isFullWidth" class="splitted-page">
        <div class="left-side" :class="brandClass()">
          <Message />
          <div id="left-loader-overlay" class="loader-overlay">
            <div class="custom-loader mini" v-if="brand=='mini'"></div>
            <div class="custom-loader rr" v-else-if="brand=='rr'"></div>
            <div class="custom-loader alphabet" v-else-if="brand=='alphabet'"></div>
            <div class="spinner-icon" v-else-if="brand=='toyota'">
              <svg class="spinner-icon-svg" width="100%" height="100%" viewBox="-10 -10 120 120">
                  <path d="M0 50A50 50 0 1 1 50 100" fill="transparent" stroke-width="10"></path>
              </svg>
            </div>
            <object v-else-if="isDarkmode" id="left-loader" type="image/svg+xml" :data="basePath+'/bmw-loading-white.svg'"></object>
            <object v-else id="left-loader" type="image/svg+xml" :data="basePath+'/bmw-loading-dark.svg'"></object>

          </div>
          <div id="wrapper" class="wrapper" :class="{extendedWrapper: isWrapperExtended}">
            <custom-page-content>
              <router-view></router-view>
            </custom-page-content>
            <OneFooter v-if="this.$route.name!='applogin'" :t="$t" :c="$c" :brandClass="brandClass()"></OneFooter>
          </div>
        </div>
        <div
          class="right-side"
          :class="brandClass()"
          :style="{'background-image': `url(${assetSource($c('image_for_background'))})`}"
        >
          <div v-if="brandClass() === '__m'" style="width: 100%; height: 20%; 
            background: linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.3), rgba(255,255,255,0));">
          </div>
          <div class="logo top right" v-if="this.imageForLogoLightMode" :class="brandClass()" >
            <img alt="" :src="assetSource(this.imageForLogoLightMode)" />
          </div>
          <div class="logo top right" v-else-if="$c('image_for_logo_top_right')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_top_right'))" />
          </div>
          <div class="logo top left" v-if="$c('image_for_logo_top_left')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_top_left'))" />
          </div>
          <div class="logo bottom right" v-if="$c('image_for_logo_bottom_right')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_bottom_right'))" />
          </div>
          <div class="logo bottom left" v-if="$c('image_for_logo_bottom_left')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_bottom_left'))" />
          </div>
        </div>
        <div
          class="right-side right-side_mobile"
          :class="brandClass()"
          :style="{
            'background-image': `url(${assetSource(
              $c('image_for_mobile_background')
            )})`,
          }"
        >
          <div class="logo top right" v-if="this.imageForLogoLightMode" :class="brandClass()" >
            <img alt="" :src="assetSource(this.imageForLogoLightMode)" />
          </div>
          <div class="logo top right" v-else-if="$c('image_for_logo_top_right')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_top_right'))" />
          </div>
          <div class="logo top left" v-if="$c('image_for_logo_top_left')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_top_left'))" />
          </div>
          <div class="logo bottom right" v-if="$c('image_for_logo_bottom_right')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_bottom_right'))" />
          </div>
          <div class="logo bottom left" v-if="$c('image_for_logo_bottom_left')" :class="brandClass()" >
            <img alt="" :src="assetSource($c('image_for_logo_bottom_left'))" />
          </div>
        </div>
      </div>
      <div v-else class="full-width-page">
        <div class="full-page">
          <!-- HEADER PLACEHOLDER -->
          <div v-if="$c('show_profile_header') && this.$route.name!='maintenance' && this.$route.name!='translations'" class="header" :class="brandClass()">
            <div class="header-logo">
              <img alt="" :src="assetSource(this.imageForLogo)" />
            </div>
          </div>
          <Message :elementId="'app-notification-message'" />
          <!--        <div id="loader-overlay" class="loader-overlay">-->
          <!--          <img id="loader" src="@/assets/loader.gif" class="loader"/>-->
          <!--        </div>-->
          <div class="wrapper" :class="{extendedWrapper: isWrapperExtended}">
             <router-view></router-view>
          </div>
          <!-- FOOTER PLACEHOLDER -->
          <div v-if="$c('show_profile_footer') && this.$route.name!='maintenance' && this.$route.name!='translations'" class="footer-wrapper">
            <OneFooter :profileStyle="true" :t="$t" :c="$c" :brandClass="brandClass()"></OneFooter>
          </div>
        </div>
      </div>
      <div style="display: none;">is-full-width: {{ isFullWidth }}</div>
    </div>
   
  </div>
</template>

<script>
import Message from "@/components/Message";
import OneFooter from "../gcdm-one-library/gcdm-one-footer/src/OneFooter";
import oneUtils from "../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import useVuelidate from '@vuelidate/core'
import { defineComponent } from 'vue';
import CustomPageContent from "./components/commons/CustomPageContent.vue";


export default defineComponent({
  setup() {
    return { v$: useVuelidate() }
  },
  props:{},
  inject:['$c', '$t', '$navigateByPath', 'brandClass', 'assetSource', 'basePath'],
  components: { Message, OneFooter, CustomPageContent },
  mixins: [oneUtils.queryInterceptorMixin, oneUtils.accessibilityMixin],
  watch: {
    currentConfiguration: {
      deep: true,
      handler() {
        oneUtils.sessionUtils.updateFavicon(this.assetSource(this.$c("image_for_favicon")));
      },
    },
  },
  data: () => ({
    showpolicy:false,
  }),
  methods:{
    closeCookiePage(){
      // const parent = this.$refs['cookiePage'];
      const parent = document.getElementById('epaas-policy-page-container');
      // const button = this.$refs['policy_back_button'];
      const button = document.getElementById('policy_back_button');
      while (parent.firstChild) {
        if(parent.firstChild){
          parent.removeChild(parent.firstChild);
        }
      }
      parent.appendChild(button);
      this.showpolicy=!this.showpolicy;
    }
  },
  computed: {
    currentConfiguration() {
      return this.$store.getters.getConfigurationParams;
    },
    brand() {
      return (
        this.$store.state.configurationParams.brand ||
        oneUtils.properties.DEFAULT_FALLBACK_BRAND
      );
    },
    isWrapperExtended() {
     const queryParams = oneUtils.utils.getQueryParams();
     const isNavigator = queryParams['navigator'] === 'true';
     const isExtended = isNavigator;
     return isExtended;
    },
    isFullWidth() {
      let pageName = this.$route.name;
      if (!pageName) {
        pageName = window.location.href.split("/#/")[1].split("?")[0];
      }
      return oneUtils.properties.FULL_WIDTH_PAGES.includes(pageName);
    },
    isDarkmode() {
      const queryParams = oneUtils.utils.getQueryParams();

      if(queryParams) {
        return (queryParams.isDarkmode && queryParams.isDarkmode == "true") || (queryParams.isDarkmode != "false" && window.localStorage.getItem("oneid_darkmode_selected_") == "true");
      }
      else {
        return window.localStorage.getItem("oneid_darkmode_selected_" + queryParams.brand) == "true";
      }
    },
    imageForLogo() {
      if(this.isDarkmode && this.$c('image_for_logo_darkmode')) {
        return this.$c('image_for_logo_darkmode');
      }

      return this.$c('image_for_logo')
    },
    imageForLogoLightMode() {
      return this.$c('image_for_logo')
    }
  },
  mounted() {
    //disable console log by environment
    oneUtils.utils.hideConsoleLogInByEnvironment();
    //store originalUrl in order to track it
    this.$store.dispatch('setupOriginalUrl',window.location.href);
    window.addEventListener("POLICY_CLICK", ()=>{
      const containerElement = document.getElementById('epaas-policy-page-container');
      window['epaas'].api.policypage.then(policypageBundle => policypageBundle.showPolicyPage(containerElement));
      this.showpolicy = !this.showpolicy;
    });
  
  },
  beforeCreate() {
    //to catch webkit autofill animation
    document.addEventListener("mousemove", (e) => {
      e.stopPropagation();
    });
  },
});
</script>

<style lang="scss">
@import "@/styles/_generalStyle.scss";
@import "@/styles/_darkmode.scss";
</style>
